// src/useAuth.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { auth, db } from "./firebase";   // import db from firebase.js
import {
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
} from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  // 🔹 Register (manual if needed)
  const signup = (email, password) => {
    return createUserWithEmailAndPassword(auth, email, password);
  };

  // 🔹 Login
  const login = (email, password) => {
    return signInWithEmailAndPassword(auth, email, password);
  };

  // 🔹 Logout
  const logout = () => {
    return signOut(auth);
  };

  // 🔹 Reset password
  const resetPassword = (email) => {
    return sendPasswordResetEmail(auth, email);
  };

  // 🔹 Listen for auth changes + fetch role from Firestore
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        console.log("✅ Signed in user:", user.email, "UID:", user.uid);

        try {
          const docRef = doc(db, "users", user.uid);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            const data = docSnap.data();
            console.log("✅ Firestore doc found for UID:", user.uid, data);

            setRole(data.role || "user"); // default role = user
            setCurrentUser({ ...user, role: data.role });
         } else {
  console.warn("⚠️ No Firestore document found for this UID:", user.uid);

  // Allow login even without Firestore role record
  setRole("user");
  setCurrentUser(user);
}

        } catch (err) {
          console.error("❌ Error fetching role:", err);

          // Extra check to distinguish UID mismatch vs rules
          console.log(
            "🔍 Double-check Firestore -> users collection has this UID:",
            user.uid
          );

          setRole(null);
          setCurrentUser(null);
        }
      } else {
        console.log("ℹ️ No user is signed in");
        setCurrentUser(null);
        setRole(null);
      }
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const value = { currentUser, role, signup, login, logout, resetPassword };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
